import React, { useEffect, useState } from 'react'
import {
  collectionGroup,
  onSnapshot,
  doc,
  updateDoc,
  setDoc, // 👈 TAMBAHAN BARU
  serverTimestamp,
  getDoc,
  collection,
  addDoc,
  getDocs,
} from 'firebase/firestore'
import { db } from '../../firebaseConfig'

export default function SaldoMitraPage() {
  const [transactions, setTransactions] = useState([])
  const [selectedTrx, setSelectedTrx] = useState(null)

  // 👈 TAMBAHAN STATE: Untuk Tab dan Data Buku Saldo
  const [activeTab, setActiveTab] = useState('buku_saldo') // Default tab
  const [mitraBalances, setMitraBalances] = useState([])
  const [totalLiability, setTotalLiability] = useState(0)

  // 🔹 STATE BARU: Untuk Fitur Penyesuaian Manual
  const [showAdjModal, setShowAdjModal] = useState(false)
  const [adjLoading, setAdjLoading] = useState(false)
  const [mitraList, setMitraList] = useState([])
  const [adjData, setAdjData] = useState({
    mitraDocPath: '', 
    type: 'adjustment_credit', 
    amount: '',
    note: '',
  })

  // --- TAMBAHAN STATE UNTUK PENGGABUNGAN DATA ---
  const [historyMitra, setHistoryMitra] = useState([])
  const [historyDriver, setHistoryDriver] = useState([])

  // Gabungkan dan urutkan setiap ada perubahan di salah satu data
  useEffect(() => {
    const combined = [...historyMitra, ...historyDriver].sort(
      (a, b) => (b.timestamp?.seconds || 0) - (a.timestamp?.seconds || 0)
    )
    setTransactions(combined)
  }, [historyMitra, historyDriver])

  // 🔹 Ambil realtime data transaksi (Terapis/Cleaner & Driver)
  useEffect(() => {
    // 1. LISTENER TERAPIS & CLEANER (Sistem Lama)
    const unsubMitra = onSnapshot(collectionGroup(db, 'saldo_history'), async (snap) => {
      const dataPromises = snap.docs.map(async (docSnap) => {
        const data = docSnap.data()
        const pathParts = docSnap.ref.path.split('/')
        
        let mitraName = data.mitraName || 'Tidak Diketahui'
        let mitraIdNumber = data.id_number || data.mitraId || '-'

        if (!data.mitraName || (!data.id_number && !data.mitraId)) {
          if (pathParts.length >= 4) {
            const parentPath = pathParts.slice(0, 2).join('/')
            try {
              const parentSnap = await getDoc(doc(db, parentPath))
              if (parentSnap.exists()) {
                const parentData = parentSnap.data()
                mitraName = parentData.name || mitraName
                mitraIdNumber = parentData.id_number || mitraIdNumber
              }
            } catch (e) {
              console.error("Gagal ambil data parent", e)
            }
          }
        }
        return { 
          id: docSnap.id, 
          ref: docSnap.ref, 
          isDriver: false, 
          ...data, 
          mitraName, 
          mitraIdNumber 
        }
      })
      const resolvedData = await Promise.all(dataPromises)
      setHistoryMitra(resolvedData)
    })

    // 2. LISTENER DRIVER (Sistem Baru - Zimo Driver)
    const unsubDriver = onSnapshot(collectionGroup(db, 'transactions'), async (snap) => {
      const dataPromises = snap.docs.map(async (docSnap) => {
        const data = docSnap.data()
        const driverId = docSnap.ref.parent.parent.id // Ambil ID Driver dari path wallets/{id}/transactions
        let mitraName = 'Driver Zimo'
        let mitraIdNumber = driverId.slice(0, 8) // Fallback pakai potongan UID

        try {
          const dSnap = await getDoc(doc(db, 'drivers', driverId))
          if (dSnap.exists()) {
            mitraName = dSnap.data().name || mitraName
            mitraIdNumber = dSnap.data().phone || mitraIdNumber
          }
        } catch (e) {
          console.error("Gagal ambil data driver", e)
        }

        // Normalisasi data agar formatnya sama dengan sistem lama
        let normalizedType = data.type
        if (data.type === 'Top Up') normalizedType = 'topup'
        if (data.type === 'Tarik Saldo') normalizedType = 'withdraw'

        return { 
          id: docSnap.id, 
          ref: docSnap.ref, 
          isDriver: true, 
          ...data, 
          type: normalizedType, 
          timestamp: data.createdAt, // Samakan nama variabel waktu agar urutannya rapi
          mitraName, 
          mitraIdNumber 
        }
      })
      const resolvedData = await Promise.all(dataPromises)
      setHistoryDriver(resolvedData)
    })

    return () => { 
      unsubMitra(); 
      unsubDriver(); 
    }
  }, [])

  // 👈 TAMBAHAN: useEffect untuk mengambil daftar saldo terkini (Buku Saldo)
  useEffect(() => {
    const fetchBalances = async () => {
      try {
        const tSnap = await getDocs(collection(db, 'therapists'))
        const cSnap = await getDocs(collection(db, 'cleaners'))
        const dSnap = await getDocs(collection(db, 'drivers')) // Ambil data driver
        const wSnap = await getDocs(collection(db, 'wallets')) // Ambil saldo dompet driver
        
        // Buat pemetaan saldo dompet berdasarkan UID
        const walletMap = {}
        wSnap.forEach(doc => { walletMap[doc.id] = doc.data().balance || 0 })

        const balances = [
          ...tSnap.docs.map(d => ({ id: d.id, path: `therapists/${d.id}`, type: 'Terapis', name: d.data().name, id_number: d.data().id_number, saldo: d.data().saldo || 0 })),
          ...cSnap.docs.map(d => ({ id: d.id, path: `cleaners/${d.id}`, type: 'Kliner', name: d.data().name, id_number: d.data().id_number, saldo: d.data().saldo || 0 })),
          ...dSnap.docs.map(d => ({ id: d.id, path: `wallets/${d.id}`, type: 'Driver', name: d.data().name || 'Driver', id_number: d.data().phone || d.id, saldo: walletMap[d.id] || 0 }))
        ]

        
        // Hitung total liabilitas (total uang mitra di sistem)
        const total = balances.reduce((sum, curr) => sum + curr.saldo, 0)
        
        setMitraBalances(balances.sort((a, b) => b.saldo - a.saldo)) // Urutkan saldo terbanyak
        setTotalLiability(total)
      } catch (error) {
        console.error("Gagal memuat buku saldo:", error)
      }
    }
    
    // Panggil saat tab aktif atau sebagai inisialisasi
    fetchBalances()
  }, [activeTab, showAdjModal]) // Refresh data saat pindah tab atau setelah modal ditutup

  // 🔹 Ambil referensi dokumen mitra
  async function getMitraDocPath(trx) {
    const pathParts = trx.ref.path.split('/')
    if (pathParts.length >= 4) {
      return pathParts.slice(0, 2).join('/')
    }
    return null
  }

  // 🔹 Update saldo mitra otomatis
  async function updateMitraSaldo(trx, isTopup) {
    const amountNum = Number(trx.amount) || 0;

    if (trx.isDriver) {
      const pathParts = trx.ref.path.split('/');
      const driverUid = pathParts[1];
      
      const walletRef = doc(db, 'wallets', driverUid)
      const wSnap = await getDoc(walletRef)
      
      const currentSaldo = wSnap.exists() ? (Number(wSnap.data().balance) || 0) : 0
      const newSaldo = isTopup ? currentSaldo + amountNum : currentSaldo - amountNum
      
      // 👈 DIUBAH MENJADI SETDOC (Otomatis membuat dokumen jika belum ada)
      await setDoc(walletRef, { balance: newSaldo }, { merge: true })
    } else {
      const mitraDocPath = await getMitraDocPath(trx)
      if (!mitraDocPath) return

      const mitraRef = doc(db, mitraDocPath)
      const mitraSnap = await getDoc(mitraRef)
      
      // Jika dokumen terapis/cleaner ternyata juga belum ada, kita amankan
      const currentSaldo = mitraSnap.exists() ? (Number(mitraSnap.data().saldo) || 0) : 0
      const newSaldo = isTopup ? currentSaldo + amountNum : currentSaldo - amountNum

      // 👈 DIUBAH MENJADI SETDOC (Aman dari error dokumen tidak ditemukan)
      await setDoc(mitraRef, { saldo: newSaldo }, { merge: true })
    }
  }

  // 🔹 Setujui transaksi
  const handleApprove = async (trx) => {
    try {
      // Deteksi tipe transaksi lebih kebal error (menghapus spasi dan huruf besar)
      const typeStr = String(trx.type || '').toLowerCase().replace(/\s+/g, '');
      const isTopup = typeStr === 'topup';
      const isWithdraw = typeStr === 'withdraw' || typeStr.includes('tarik');

      await updateDoc(trx.ref, {
        status: trx.isDriver ? 'Berhasil' : 'approved',
        admin_id: 'system_admin',
        admin_approved_at: serverTimestamp(),
      })

      // LOGIKA KEUANGAN YANG BENAR
      if (trx.isDriver) {
        if (isTopup) {
          // Jika Top Up disetujui, TAMBAHKAN saldonya
          await updateMitraSaldo(trx, true)
        }
      } else {
        // Logika bawaan untuk sistem lama (Terapis/Cleaner)
        if (isTopup || isWithdraw) {
          await updateMitraSaldo(trx, isTopup)
        }
      }

      setSelectedTrx(null)
    } catch (err) {
      console.error(err)
      alert('❌ Gagal menyetujui transaksi.')
    }
  }

  // 🔹 Tolak transaksi
  const handleReject = async (trx) => {
    try {
      // Deteksi tipe transaksi lebih kebal error
      const typeStr = String(trx.type || '').toLowerCase().replace(/\s+/g, '');
      const isWithdraw = typeStr === 'withdraw' || typeStr.includes('tarik');

      await updateDoc(trx.ref, {
        status: trx.isDriver ? 'Dibatalkan' : 'rejected',
        admin_id: 'system_admin',
        admin_approved_at: serverTimestamp(),
      })

      // LOGIKA KEUANGAN REFUND (PENGEMBALIAN DANA)
      if (trx.isDriver && isWithdraw) {
        // Jika Tarik Saldo DITOLAK admin, KEMBALIKAN (refund) uangnya ke dompet Driver!
        await updateMitraSaldo(trx, true) 
      }

      setSelectedTrx(null)
    } catch (err) {
      console.error(err)
      alert('❌ Gagal menolak transaksi.')
    }
  }

  // 🔹 FUNGSI BARU: Load List Mitra untuk Dropdown
  const loadMitraList = async () => {
    try {
      const tSnap = await getDocs(collection(db, 'therapists'))
      const cSnap = await getDocs(collection(db, 'cleaners'))
      
      const combined = [
        ...tSnap.docs.map(d => ({ path: `therapists/${d.id}`, name: d.data().name, id_number: d.data().id_number, type: 'Therapist' })),
        ...cSnap.docs.map(d => ({ path: `cleaners/${d.id}`, name: d.data().name, id_number: d.data().id_number, type: 'Cleaner' }))
      ]
      setMitraList(combined)
    } catch (e) {
      console.error("Gagal meload mitra list", e)
    }
  }

  // 🔹 FUNGSI BARU: Eksekusi Penyesuaian Saldo Manual
  const handleManualAdjustment = async (e) => {
    e.preventDefault()
    if (!adjData.mitraDocPath || !adjData.amount || !adjData.note) {
      return alert('Lengkapi semua data penyesuaian!')
    }

    setAdjLoading(true)
    try {
      const amountNum = parseInt(adjData.amount, 10)
      if (isNaN(amountNum) || amountNum <= 0) throw new Error('Nominal tidak valid')

      const mitraRef = doc(db, adjData.mitraDocPath)
      const mitraSnap = await getDoc(mitraRef)
      if (!mitraSnap.exists()) throw new Error('Data mitra tidak ditemukan')

      const dataMitra = mitraSnap.data()
      const currentSaldo = dataMitra.saldo || 0
      const isCredit = adjData.type === 'adjustment_credit'
      
      const newSaldo = isCredit ? currentSaldo + amountNum : currentSaldo - amountNum
      const historyType = isCredit ? 'credit' : 'withdraw' 
      
      await addDoc(collection(mitraRef, 'saldo_history'), {
        amount: amountNum,
        type: historyType, 
        status: 'approved', 
        note: `(Manual) ${adjData.note}`,
        timestamp: serverTimestamp(),
        admin_id: 'system_admin'
      })

      await updateDoc(mitraRef, { saldo: newSaldo })

      alert('✅ Penyesuaian Saldo Berhasil!')
      setShowAdjModal(false)
      setAdjData({ mitraDocPath: '', type: 'adjustment_credit', amount: '', note: '' })
    } catch (error) {
      console.error(error)
      alert(`❌ Gagal: ${error.message}`)
    } finally {
      setAdjLoading(false)
    }
  }

  return (
    <div>
      {/* 👈 TAMBAHAN: Card Total Liabilitas */}
      <div className="bg-gradient-to-r from-red-900 to-orange-900 p-6 rounded-xl border border-red-800 shadow-lg mb-6">
        <h2 className="text-red-200 text-sm font-medium mb-1">Total Uang Mitra di Sistem (Liabilitas)</h2>
        <h1 className="text-4xl font-bold text-white">
          Rp {totalLiability.toLocaleString('id-ID')}
        </h1>
        <p className="text-red-300 text-xs mt-2 opacity-80">
          *Total keseluruhan saldo aktif milik seluruh mitra yang wajib dicadangkan.
        </p>
      </div>

      {/* 👈 TAMBAHAN: Sistem Tab Navigasi */}
      <div className="flex border-b border-gray-800 mb-6">
        <button
          onClick={() => setActiveTab('buku_saldo')}
          className={`py-3 px-6 font-semibold text-sm focus:outline-none transition-colors ${
            activeTab === 'buku_saldo' 
              ? 'border-b-2 border-blue-500 text-blue-400' 
              : 'text-gray-500 hover:text-gray-300'
          }`}
        >
          📖 Buku Saldo Terkini
        </button>
        <button
          onClick={() => setActiveTab('riwayat')}
          className={`py-3 px-6 font-semibold text-sm focus:outline-none transition-colors ${
            activeTab === 'riwayat' 
              ? 'border-b-2 border-blue-500 text-blue-400' 
              : 'text-gray-500 hover:text-gray-300'
          }`}
        >
          🕒 Riwayat Transaksi
        </button>
      </div>

      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold text-gray-100">
          {activeTab === 'riwayat' ? 'Riwayat Transaksi Masuk/Keluar' : 'Daftar Saldo Per Mitra'}
        </h2>
        
        {/* 👈 TOMBOL BARU: Penyesuaian Manual */}
        <button
          onClick={() => {
            setShowAdjModal(true)
            loadMitraList()
          }}
          className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-lg"
        >
          ⚙️ Penyesuaian Manual
        </button>
      </div>

      {/* 👈 KONTEN TAB: BUKU SALDO */}
      {activeTab === 'buku_saldo' && (
        <div className="overflow-x-auto border border-gray-800 rounded-lg bg-gray-900 mb-8">
          <table className="min-w-full text-sm text-left text-gray-300">
            <thead className="bg-gray-800 text-gray-400 uppercase text-xs">
              <tr><th className="px-4 py-3">Nama Mitra</th><th className="px-4 py-3">ID Mitra</th><th className="px-4 py-3">Tipe</th><th className="px-4 py-3 text-right">Saldo Terkini</th><th className="px-4 py-3 text-center">Status Saldo</th></tr>
            </thead>
            <tbody className="divide-y divide-gray-800">
              {mitraBalances.length === 0 ? (
                <tr><td colSpan="5" className="text-center py-6 text-gray-500">Memuat data saldo...</td></tr>
              ) : (
                mitraBalances.map((m) => (
                  <tr key={m.path} className="hover:bg-gray-800/70 transition">
                    <td className="px-4 py-3 font-semibold text-gray-100">{m.name}</td>
                    <td className="px-4 py-3 text-gray-400 font-mono">{m.id_number}</td>
                    <td className="px-4 py-3 text-gray-400">{m.type}</td>
                    <td className="px-4 py-3 text-right font-bold text-blue-400">
                      Rp {m.saldo.toLocaleString('id-ID')}
                    </td>
                    <td className="px-4 py-3 text-center">
                      {m.saldo < 10000 ? (
                        <span className="bg-red-900/40 text-red-400 px-2 py-1 rounded text-xs font-semibold animate-pulse border border-red-800">Minim</span>
                      ) : (
                        <span className="bg-green-900/30 text-green-400 px-2 py-1 rounded text-xs font-semibold">Aman</span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* 👈 KONTEN TAB: RIWAYAT TRANSAKSI (Kode lama dibungkus pengecekan tab) */}
      {activeTab === 'riwayat' && (
        <div className="overflow-x-auto border border-gray-800 rounded-lg bg-gray-900">
          <table className="min-w-full text-sm text-left text-gray-300">
            <thead className="bg-gray-800 text-gray-400 uppercase text-xs">
              <tr>
                <th className="px-4 py-3">Tipe</th>
                <th className="px-4 py-3">Mitra</th>
                <th className="px-4 py-3">Jumlah</th>
                <th className="px-4 py-3">Status</th>
                <th className="px-4 py-3">Waktu</th>
              </tr>
            </thead>
          <tbody>
            {transactions.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center py-6 text-gray-500"> {/* 👈 Ubah jadi 5 */}
                  Tidak ada transaksi saldo mitra.
                </td>
              </tr>
            ) : (
              transactions.map((trx, index) => (
                <tr
                  key={trx.ref?.path || `${trx.id}-${index}`} // 👈 KUNCI UNIK ANTI BENTROK
                  className="border-t border-gray-800 hover:bg-gray-800/70 transition cursor-pointer"
                  onClick={() => setSelectedTrx(trx)}
                >
                  <td className="px-4 py-2 capitalize font-medium">{trx.type}</td>
                  
                  {/* 👈 ISI KOLOM MITRA BARU */}
                  <td className="px-4 py-2">
                    <div className="font-semibold text-gray-100">{trx.mitraName}</div>
                    <div className="text-xs text-gray-500">{trx.mitraIdNumber}</div>
                  </td>

                  <td className="px-4 py-2 text-blue-400 font-semibold">
                    Rp {trx.amount?.toLocaleString('id-ID')}
                  </td>
                  <td
                    className={`px-4 py-2 font-medium capitalize ${
                      trx.status?.toLowerCase() === 'approved' || trx.status?.toLowerCase() === 'berhasil'
                        ? 'text-green-500'
                        : trx.status?.toLowerCase() === 'pending'
                        ? 'text-yellow-400'
                        : 'text-red-400'
                    }`}
                  >
                    {trx.status}
                  </td>
                  <td className="px-4 py-2 text-gray-500 text-xs">
                    {trx.timestamp
                      ? new Date(trx.timestamp.seconds * 1000).toLocaleString(
                          'id-ID'
                        )
                      : '-'}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      )} {/* 👈 PENUTUP UNTUK TAB RIWAYAT TRANSAKSI */}

      {/* 🔹 Modal Detail Transaksi */}
      {selectedTrx && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-900 border border-gray-700 rounded-xl w-full max-w-md p-6 shadow-lg">
            <h3 className="text-lg font-semibold text-blue-400 border-b border-gray-800 pb-3 mb-4">
              Detail Transaksi
            </h3>

            <div className="text-sm text-gray-300 space-y-3">
              {/* 👈 TAMBAHAN KOTAK NAMA & ID MITRA */}
              <div className="bg-gray-800 p-3 rounded-lg mb-2 border border-gray-700">
                <p className="text-xs text-gray-400 mb-1">Informasi Mitra:</p>
                <p className="font-bold text-white text-base">{selectedTrx.mitraName}</p>
                <p className="text-gray-400 font-mono text-xs">{selectedTrx.mitraIdNumber}</p>
              </div>

              <p>
                <b>Tipe:</b> <span className="capitalize">{selectedTrx.type}</span>
              </p>
              <p>
                <b>Jumlah:</b> Rp {selectedTrx.amount?.toLocaleString('id-ID')}
              </p>
              <p>
                <b>Status:</b> {selectedTrx.status}
              </p>
              {selectedTrx.method && (
                <p>
                  <b>Metode:</b> {selectedTrx.method}
                </p>
              )}
              {selectedTrx.bank_name && (
                <p>
                  <b>Bank Asal:</b> {selectedTrx.bank_name}
                </p>
              )}
              {selectedTrx.account_name && (
                <p>
                  <b>Nama Akun:</b> {selectedTrx.account_name}
                </p>
              )}
              {selectedTrx.account_number && (
                <p>
                  <b>Nomor:</b> {selectedTrx.account_number}
                </p>
              )}
              {selectedTrx.note && (
                <p>
                  <b>Catatan:</b> {selectedTrx.note}
                </p>
              )}
              <p>
                <b>Tanggal:</b>{' '}
                {selectedTrx.timestamp
                  ? new Date(
                      selectedTrx.timestamp.seconds * 1000
                    ).toLocaleString('id-ID')
                  : '-'}
              </p>
            </div>

            <div className="flex justify-end gap-3 mt-5">
              {selectedTrx.status?.toLowerCase() === 'pending' && (
                <>
                  <button
                    onClick={() => handleApprove(selectedTrx)}
                    className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white text-sm rounded-lg"
                  >
                    Setujui
                  </button>
                  <button
                    onClick={() => handleReject(selectedTrx)}
                    className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm rounded-lg"
                  >
                    Tolak
                  </button>
                </>
              )}
              <button
                onClick={() => setSelectedTrx(null)}
                className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white text-sm rounded-lg"
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 🔹 MODAL BARU: Penyesuaian Saldo Manual */}
      {showAdjModal && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-gray-900 border border-purple-700 rounded-xl w-full max-w-md p-6 shadow-2xl">
            <h3 className="text-lg font-semibold text-purple-400 border-b border-gray-800 pb-3 mb-4">
              ⚙️ Penyesuaian Saldo Manual
            </h3>
            
            <form onSubmit={handleManualAdjustment} className="space-y-4">
              <div>
                <label className="block text-gray-400 text-sm mb-1">Pilih Mitra</label>
                <select 
                  required
                  value={adjData.mitraDocPath}
                  onChange={e => setAdjData({...adjData, mitraDocPath: e.target.value})}
                  className="w-full bg-gray-800 border border-gray-700 rounded-lg p-2 text-white outline-none"
                >
                  <option value="">-- Pilih Mitra --</option>
                  {mitraList.map(m => (
                    <option key={m.path} value={m.path}>
                      [{m.type}] {m.name} ({m.id_number})
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-gray-400 text-sm mb-1">Jenis Penyesuaian</label>
                <div className="flex gap-4">
                  <label className="flex items-center text-white cursor-pointer">
                    <input type="radio" name="adjType" value="adjustment_credit" 
                      checked={adjData.type === 'adjustment_credit'}
                      onChange={e => setAdjData({...adjData, type: e.target.value})}
                      className="mr-2"
                    /> ➕ Tambah Saldo
                  </label>
                  <label className="flex items-center text-white cursor-pointer">
                    <input type="radio" name="adjType" value="adjustment_debit" 
                      checked={adjData.type === 'adjustment_debit'}
                      onChange={e => setAdjData({...adjData, type: e.target.value})}
                      className="mr-2"
                    /> ➖ Kurangi Saldo
                  </label>
                </div>
              </div>

              <div>
                <label className="block text-gray-400 text-sm mb-1">Nominal (Rp)</label>
                <input 
                  type="number" required min="1"
                  placeholder="Contoh: 50000"
                  value={adjData.amount}
                  onChange={e => setAdjData({...adjData, amount: e.target.value})}
                  className="w-full bg-gray-800 border border-gray-700 rounded-lg p-2 text-white outline-none"
                />
              </div>

              <div>
                <label className="block text-gray-400 text-sm mb-1">Alasan / Catatan</label>
                <input 
                  type="text" required
                  placeholder="Misal: Kompensasi error / Setor tunai"
                  value={adjData.note}
                  onChange={e => setAdjData({...adjData, note: e.target.value})}
                  className="w-full bg-gray-800 border border-gray-700 rounded-lg p-2 text-white outline-none"
                />
              </div>

              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button" disabled={adjLoading}
                  onClick={() => setShowAdjModal(false)}
                  className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white text-sm rounded-lg"
                >
                  Batal
                </button>
                <button
                  type="submit" disabled={adjLoading}
                  className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white text-sm rounded-lg font-bold"
                >
                  {adjLoading ? 'Menyimpan...' : 'Eksekusi Saldo'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
